module.exports = __webpack_public_path__ + "img/pattern_img.defeee8e.png";